module.exports = __webpack_public_path__ + "img/icon-close.606e35ce.svg";